import Rubrique from '@/generated/classes/Rubrique';
import { RubriquePaie as RubriquePaieBase } from '@/generated/classes/Rubrique';
import { VariablePaie as VariablePaieBase } from '@/generated/classes/Rubrique';
import { BaseSalarie as BaseSalarieBase } from '@/generated/classes/Rubrique';
export default class RubriqueExtend extends Rubrique {
  constructor() {
    super();
  }
}
export class RubriquePaie extends RubriquePaieBase {
  constructor() {
    super();
  }
}
export class VariablePaie extends VariablePaieBase {
  constructor() {
    super();
  }
}
export class BaseSalarie extends BaseSalarieBase {
  constructor() {
    super();
  }
}
